/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><path pid="0" d="M4.644 14.655l-4.31 1.012 1.01-4.31L11.977.724a1.333 1.333 0 011.886 0l1.415 1.414a1.333 1.333 0 010 1.886L4.644 14.655z"/><path pid="1" d="M14.807 4.497l-3.302-3.302"/><path pid="2" d="M13.855 5.448l-3.294-3.31"/><path pid="3" d="M4.812 14.489l-3.3-3.3"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/edit.js